import { nativeService } from './service';

class NativeReviewPromptService {
  request():Promise<void> {
    return nativeService.run('request-review')
  }
}

export const nativeReviewPromptService = new NativeReviewPromptService();
